import { render, staticRenderFns } from "./MultilingualResourcePreviewCards.vue?vue&type=template&id=4cb2740a&scoped=true"
import script from "./MultilingualResourcePreviewCards.vue?vue&type=script&lang=js"
export * from "./MultilingualResourcePreviewCards.vue?vue&type=script&lang=js"
import style0 from "./MultilingualResourcePreviewCards.vue?vue&type=style&index=0&id=4cb2740a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb2740a",
  null
  
)

export default component.exports